import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './components/work-logs/App.vue';
import formatDate from 'date-fns/format';

export default function(options) {
  const router = new VueRouter({
    routes: [
      {
        path: '/week/:slug',
        component: App,
        props(route) {
          return {
            slug: route.params.slug,
            currentLockTime: options.lockTime,
            canLogWork: !!options.canLogWork,
            layout: 'week',
          }
        }
      },
      {
        path: '/list/:slug',
        component: App,
        props(route) {
          return {
            slug: route.params.slug,
            currentLockTime: options.lockTime,
            canLogWork: !!options.canLogWork,
            layout: 'list',
          }
        }
      },
      {path: '*', redirect() {
        const now = new Date();
        return '/list/'+formatDate(new Date, 'YYYY-MM-DD');
      }},
    ]
  });

  Vue.use(VueRouter);
  new Vue({
    router
  }).$mount('#app');
}



// WEBPACK FOOTER //
// ./assets/js/worklogs.js